import { PaymentMethodInfo } from "./payment-method-info";

export class CCPaymentInfo extends PaymentMethodInfo {
  NameOnCard: string;
  CreditCardNumber: string;
  ExpirationDate: string;
  CVVCode: string;
}
